// A choice chip (Figma "Chip"): quick replies, filters, "how did it feel".
import * as React from 'react';
import { cn } from '../../lib/utils';
import { FOCUS } from './Button';

export function Chip({ selected = false, className, children, ...props }) {
  return (
    <button type="button" aria-pressed={selected}
      className={cn('inline-flex h-9 items-center whitespace-nowrap rounded-full border px-3 type-button-small transition-colors', FOCUS,
        selected ? 'border-accent-default bg-accent-tint text-accent-default'
          : 'border-border-default bg-bg-surface text-text-body hover:border-border-strong',
        className)}
      {...props}>
      {children}
    </button>
  );
}
